<div
    class="ei-btn-wrap"
    [class.ei-btn-wrap--full-width]="fullWidth()"
    [class.ei-btn--left]="position() === 'left'"
    [class.ei-btn--right]="position() === 'right'"
>
    <button
        class="ei-btn"
        [attr.type]="type()"
        [disabled]="disabled() || loading()"
        [attr.aria-busy]="loading() ? 'true' : null"
        [attr.aria-label]="buttonAriaLabel()"
        [class]="buttonClassList()"
        (click)="onClick($event)"
    >
        @if (loading()) {
            <span class="ei-btn__dots" aria-hidden="true">
                <span class="ei-btn__dot"></span>
                <span class="ei-btn__dot"></span>
                <span class="ei-btn__dot"></span>
            </span>
        } @else if (showLeftIcon() && icon()) {
            @if (isIconSrc()) {
                <img class="ei-btn__icon ei-btn__icon--img" [src]="icon()!" alt="" />
            } @else {
                <span class="ei-btn__icon"><app-svg-icon [name]="icon()!" size="sm" /></span>
            }
        }

        @if (!loading() && showText()) {
            <span class="ei-btn__text">
                @if (label() !== undefined && label() !== null) {
                    {{ label() }}
                } @else {
                    <ng-content></ng-content>
                }
            </span>
        }

        @if (!loading() && showRightIcon() && icon()) {
            @if (isIconSrc()) {
                <img class="ei-btn__icon ei-btn__icon--img" [src]="icon()!" alt="" />
            } @else {
                <span class="ei-btn__icon"><app-svg-icon [name]="icon()!" size="sm" /></span>
            }
        }

        @if (!loading() && isIconOnly() && icon()) {
            @if (isIconSrc()) {
                <img class="ei-btn__icon ei-btn__icon--img" [src]="icon()!" alt="" />
            } @else {
                <span class="ei-btn__icon"><app-svg-icon [name]="icon()!" size="sm" /></span>
            }
        }
    </button>
</div>
